<template>
    <div class="input-search">
        <div class="search-bar">
            <div class="clear-search" @click="emptied" v-if="canClose">
                <span class="material-icons">cancel</span>
            </div>
            <input v-bind:placeholder="placeholder" class="input-multiple-field" v-model="searchValue"
               autocomplete="off" type="text"  @click="checkSearch" @keyup="runSearch"  />
        </div>
        <div v-if="showResults" class="search-container">
            <div class="search-wrap">
                <ul v-if="searchResults.length > 0" class="styled">
                    <li v-for="(result,index) in searchResults">
                        <a href="" v-html="result.value" @click.prevent="addItem(result,index)"></a>
                    </li>
                </ul>
                <ul v-if="searchResults.length == 0" class="styled">
                    <li class="lighten">
                        <a @click.prevent href="" v-html="noResultsMessage"></a>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="selected.length > 0" class="input-tags">
            <div class="tags">
                <div v-for="(item, index) in selected" class="pill green inline">
                    <div class="flex-center">
                        <div v-html="item.value"></div>
                        <div class="flex-filler"></div>
                        <div @click="remove(index)" class="material-icons">close</div>
                    </div>

                    <input v-bind:name="inputName+'[key][]'" v-bind:value="item.key" type="hidden"/>
                    <input v-bind:name="inputName+'[value][]'" v-bind:value="item.value" type="hidden"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.inputName = this.name;
            this.selected = this.fields;
        },
        data:function() {
            return {
                inputName:'',
                canClose:false,
                searchTimeout:false,
                searchValue:'',
                searchResults:[],
                showResults: false,
                selected:[],
            }
        },
        props:{
            url:{
                type:String,
                default:"",
            },
            name:{
                type:String,
                default:"",
            },
            placeholder:{
                type:String,
                default:"",
            },
            noResultsMessage: {
                type:String,
                default:"No results found"
            },
            other:{
                type:Boolean,
                default:true
            },
            fields:{
                type:Array,
                default:[]
            }
        },
        methods: {
            emptied:function() {
                this.showResults = false;
                this.searchResults = [];
                this.searchValue = '';
                this.canClose = false;
            },
            checkSearch:function() {
                if(this.searchResults.length > 0) {
                    this.showResults = true;
                }
            },
            runSearch:function() {
                if (this.searchValue != ""){
                    this.canClose = true;
                    if(this.other) {
                        this.searchResults[0] = {
                            key:"OTHER",
                            value:this.searchValue
                        }
                        this.showResults = true;
                        this.$forceUpdate();
                    }
                    var input = this;
                    clearTimeout(this.searchTimeout);
                    this.searchTimeout = setTimeout(function () {
                        input.inputSearch();
                    },100);
                } else {
                    this.canClose = false;
                    this.showResults = false;
                    this.searchResults = [];
                }
            },
            inputSearch:function(){
                var e = this;
                if (this.url != ""){
                    $.get(this.url, {s: e.searchValue}, function (result) {
                        if (result.status == 200) {
                            var data = result.data;
                            if(e.other) {
                                data.unshift({
                                    key:"OTHER",
                                    value:e.searchValue
                                });
                            }
                            e.searchResults = data;
                            e.showResults = true;
                        } else {
                            alert(result.msg);
                        }
                    });
                } else {
                    alert('No search URL defined.');
                }
            },
            addItem:function (result,index) {
                var e = this;
                e.selected.push(result);
                e.showResults = false;
                e.$delete(e.searchResults,index);
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                },100);
            },
            remove:function(index) {
                var e = this;
                e.$delete(e.selected,index);
                setTimeout(function() {
                    e.$root.$setModalItemHeight();
                },100);
            }
        },
        mounted:function() {

        }
    }
</script>
